<template>
  <div class="qrcode-all">
    <el-button type="info" size="small" @click="handleOpen">
      <svg-icon :icon-class="pageTitle.iconss" style="margin-right: 4px" />{{ pageTitle.btnText }}</el-button
    >
    <c-dialog :visible="showDrawer" :title="pageTitle.tips" width="600px" @close="handleClose" destroy-on-close>
      <template slot="content">
        <!--      <div style="position: relative;">-->
        <!--        <div class="share-detail-header">-->
        <!--          <div class="share-detail-header-title">{{ pageTitle.tips }}</div>-->
        <!--        </div>-->
        <!--        <div class="close-box">-->
        <!--          <el-button class="close-button" size="small" @click="handleClose">关闭</el-button>-->
        <!--        </div>-->
        <!--      </div>-->
        <div class="qrcode-container">
          <div class="qrcode-box">
            <div ref="image" class="qrcode-image"></div>
            <div class="qrcode-text">{{ pageTitle.qrcodeText }}</div>
            <el-button type="info" size="small" @click="handleDown('qrcode')">
              <span>{{ $t('header.qrcode') }}</span>
            </el-button>
          </div>
          <div class="qrcode-box" v-loading="!checkinMiniAppQrcodeUrl">
            <el-image class="qrcode-image" :src="checkinMiniAppQrcodeUrl"></el-image>
            <div class="qrcode-text">{{ pageTitle.qrcodeMiniText }}</div>
            <el-button type="info" size="small" @click="handleDown('qrcodeMini')">
              <span>{{ $t('header.qrcodeMini') }}</span>
            </el-button>
          </div>
        </div>
      </template>
    </c-dialog>
  </div>
</template>
<script>
import { Message } from 'element-ui'
import QRCode from 'qrcodejs2'

export default {
  name: 'QrcodeDialog',
  components: {},
  props: {
    type: {
      type: String,
      default: ''
    }
  },
  data() {
    const merchantInfo = this.$store.state.MerchantMe.merchantInfo
    return {
      merchantId: merchantInfo && merchantInfo.merchantId,
      checkinMiniAppQrcodeUrl: '',
      showDrawer: false
    }
  },

  computed: {
    pageTitle() {
      switch (this.type) {
        case 'manager':
          return {
            iconss: 'mobile-icon',
            btnText: this.$t('header.mobile'),
            tips: this.$t('header.tips', { name: this.$t('header.mobile') }),
            qrcodeText: this.$t('header.qrcodeText', { name: this.$t('header.mobile') }),
            qrcodeMiniText: this.$t('header.qrcodeMiniText', { name: this.$t('header.mobile') })
          }
        case 'apply':
          return {
            iconss: 'mobile-registration',
            btnText: this.$t('header.register'),
            tips: this.$t('header.tips', { name: this.$t('header.register') }),
            qrcodeText: this.$t('header.qrcodeText', { name: this.$t('header.register') }),
            qrcodeMiniText: this.$t('header.qrcodeMiniText', { name: this.$t('header.register') })
          }
        default:
          return {
            btnText: '',
            tips: ''
          }
      }
    }
  },

  methods: {
    async handleOpen() {
      this.showDrawer = true
      await this.$nextTick()
      this.initData()
      this.fetchCompetitionMiniApp()
    },
    handleClose() {
      this.showDrawer = false
      this.checkinMiniAppQrcodeUrl = ''
    },
    // 获取参数
    async initData() {
      if (this.type === 'manager') {
        /* eslint-disable */
        new QRCode(this.$refs.image, {
          width: 1000,
          height: 1000, // 高度
          text: process.env.H5_MB_URL
        })
        return
      }
      if (this.type === 'apply') {
        // 商户主页面
        const url = new URL(`${process.env.EVENT_WEB_URL}event/merchant`)
        const searchParams = url.searchParams
        const merchantId = this.$store.state.MerchantMe.merchantInfo && this.$store.state.MerchantMe.merchantInfo.merchantId
        if (!merchantId) {
          Message.warning('商户信息加载中，请稍后再试')
          return
        }
        searchParams.append('merchantId', merchantId)
        /* eslint-disable */
        new QRCode(this.$refs.image, {
          width: 1000,
          height: 1000, // 高度
          text: url.toString()
        })
        return
      }
    },

    /**
     * 获取活动小程序签到二维码
     */
    async fetchCompetitionMiniApp() {
      let result = null
      const envObj = {
        production: 'release',
        test: 'trial',
        development: 'trial',
        pre: 'trial'
      }
      try {
        if (this.type === 'manager') {
          result = await this.$store.dispatch('MerchantCommon/generateManagerMiniappCode', {
            path: 'pages/index',
            // path: 'pages/scene/index',
            width: 1000,
            scene: '-1',
            isHyaline: '2',
            env: envObj[process.env.NODE_ENV] || ''
          })
        }
        if (this.type === 'apply') {
          const merchantId = this.$store.state.MerchantMe.merchantInfo && this.$store.state.MerchantMe.merchantInfo.merchantId
          if (!merchantId) {
            Message.warning('商户信息加载中，请稍后再试')
            return
          }
          const data = `path=/event/merchant&merchantId=${merchantId}`
          const scene = await this.$store.dispatch('MerchantCommon/saveCacheData', {
            data
          })
          result = await this.$store.dispatch('MerchantCommon/generateMiniappCode', {
            path: 'pages/scene/index',
            width: 1000,
            scene,
            isHyaline: '2',
            env: envObj[process.env.NODE_ENV] || ''
          })
        }
      } catch (error) {
        Message({
          message: error.message,
          type: 'error',
          duration: 10 * 1000
        })
        return
      }
      const buffer = new Uint8Array(result.data)
      const base64String = btoa(buffer.reduce((data, byte) => data + String.fromCharCode(byte), ''))
      const imgSrc = 'data:image/png;base64,' + base64String
      this.checkinMiniAppQrcodeUrl = imgSrc
    },
    handleDown(type) {
      if (type === 'qrcode') {
        const qrCanvas = this.$refs.image.getElementsByTagName('canvas')
        const qrurl = qrCanvas[0].toDataURL('image/jpg')
        let a = document.createElement('a')
        document.body.appendChild(a)
        a.href = qrurl
        a.download = `${this.pageTitle.qrcodeMiniText}.png`
        a.click()
        document.body.removeChild(a)
      }
      if (type === 'qrcodeMini') {
        let a = document.createElement('a')
        document.body.appendChild(a)
        a.href = this.checkinMiniAppQrcodeUrl
        a.download = `${this.pageTitle.qrcodeMiniText}.png`
        a.click()
        document.body.removeChild(a)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.qrcode-all {
  margin-left: 10px;
}

/deep/ .el-button--info {
  color: #687583;
  background-color: #f6f6f9;
  border-color: #f6f6f9;
}

.qrcode-container {
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding: 40px 0 40px 0;
}

.share-detail-header {
  position: relative;
  text-align: left;
  color: var(--color-primary);
  font-size: 14px;
  padding-top: 20px;
  background: linear-gradient(to right, #ddd, #ddd) no-repeat;
  background-size: 100% 1px;
  background-position: bottom;

  .share-detail-header-title {
    display: inline-block;
    padding-bottom: 14px;
    position: relative;

    &::after {
      content: ' ';
      display: block;
      width: 100%;
      height: 4px;
      border-radius: 2px;
      background-color: var(--color-primary);
      position: absolute;
      bottom: -2px;
      left: 0;
      /* transform: translateX(-50%); */
    }
  }
}

.close-box {
  position: absolute;
  right: 0;
  top: 10px;

  .close-button {
    color: var(--color-info);
    background-color: #e5e5e5;
    border-color: #e5e5e5;
  }
}

.qrcode-image {
  width: 240px;
  height: 240px;

  /deep/ img {
    height: 100%;
    width: 100%;
  }
}

.qrcode-box {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  font-size: 20px;
  font-weight: 500;
}

.qrcode-text {
  padding-top: 10px;
  padding-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/QrcodeDialog/index.vue